import React from "react"
import { Grid, CmsImage } from "@bw/bits"
import { Teaser } from "@bw/partials"
import useEventCollection from "../../../../hooks/useEventCollection"
import dateFormat from "../../../../utils/dateFormat"

const Events = () => {
  const events = useEventCollection()
  return (
    <Grid>
      {events.upcoming.map(event => {
        return (
          <Teaser
            title={event.title}
            suptitle={dateFormat(event.date)}
            excerpt={event.teaserExcerpt}
            to={event.url}
            image={
              event.teaserImage ? (
                <CmsImage
                  src={event.teaserImage}
                  alt={event?.teaserImage?.alt}
                />
              ) : undefined
            }
          />
        )
      })}
    </Grid>
  )
}

export { Events }
